import GalleryContainer from 'components/Gallery/GalleryContainer'
import GalleryPresentation from 'components/Gallery/GalleryPresentation'
import GalleryPresentationThumbnail from 'components/Gallery/GalleryPresentationThumbnail'
import GalleryData from 'components/Gallery/GalleryData'

export default {
  Container: GalleryContainer,
  Presentation: GalleryPresentation,
  PresentationThumbnail: GalleryPresentationThumbnail,
  Data: GalleryData,
}
